const PlayerAvatar = ({ initials, size = 'md', inverted = false, color }) => {
  const sizes = {
    sm: 'w-6 h-6 text-[10px]',
    md: 'w-8 h-8 text-xs',
    lg: 'w-12 h-12 text-base',
  };

  // Helper function to determine if a color is light or dark
  const isLightColor = (hexColor) => {
    if (!hexColor) return false;

    // Convert hex to RGB
    const hex = hexColor.replace('#', '');
    const r = parseInt(hex.substr(0, 2), 16) / 255;
    const g = parseInt(hex.substr(2, 2), 16) / 255;
    const b = parseInt(hex.substr(4, 2), 16) / 255;

    // Calculate relative luminance
    const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

    // Return true if light (luminance > 0.5)
    return luminance > 0.5;
  };

  const style = color
    ? {
        backgroundColor: color,
        color: isLightColor(color) ? '#18181b' : '#ffffff',
        borderColor: color,
      }
    : {
        backgroundColor: inverted ? '#18181b' : '#f4f4f5',
        color: inverted ? '#ffffff' : '#18181b',
        borderColor: inverted ? '#18181b' : '#e4e4e7',
      };

  return (
    <div
      className={`${sizes[size]} rounded flex items-center justify-center font-bold border transition-all shrink-0`}
      style={style}
    >
      {initials}
    </div>
  );
};

export default PlayerAvatar;
